import { render } from "./SideNav.vue?vue&type=template&id=2ba4fc50&scoped=true"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=2ba4fc50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba4fc50"]])

export default __exports__